import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  href,
  onClick
}: ButtonProps) {
  const sharedClassName = `
    inline-block cursor-pointer relative overflow-hidden rounded-lg bg-gold px-8 py-4 font-sans font-bold text-navy-dark 
    shadow-[0_0_20px_rgba(212,168,83,0.3)] transition-all hover:bg-gold-light 
    hover:shadow-[0_0_30px_rgba(212,168,83,0.5)] no-underline text-center
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const content = <>
      <span className="relative z-10 flex items-center justify-center gap-2 text-lg tracking-wide" data-id="element-93">
        {children}
      </span>
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-1000 hover:translate-x-full" data-id="element-94" />
    </>;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClassName} data-id="element-95">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClassName} data-id="element-96">
      {content}
    </motion.button>;
}